'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

export default function ScrollToTop() {
    const pathname = usePathname();

    useEffect(() => {
        // Force scroll to top on route change with a slight delay to ensure render is complete
        // Using 'instant' behavior to avoid visual scrolling
        // Also handling edge cases where browsers might try to restore scroll

        const scroll = () => {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'instant'
            });
        };

        scroll();

        // Double check after a frame to fight browser restoration
        requestAnimationFrame(scroll);

    }, [pathname]);

    return null;
}
